import { defineMessages } from 'react-intl';

export default defineMessages({
  signed: {
    id: 'This content was reviewed and approved by {profession} {name} on {date}',
    defaultMessage: 'This content was reviewed and approved by {profession} {name} on {date}',
  },
  redactedAndSigned: {
    id: 'This article has been written and endorsed by {profession} {name}',
    defaultMessage: 'This article has been written and endorsed by {profession} {name}',
  },
});
